// Store Locator JS (v1.2)
// This file should be saved as store-locator.js.liquid in the assets folder

(function() {
  // Create a namespace for the store locator to avoid conflicts
  window.branchStoreLocator = {};
  
  // Settings - can be overridden via data attributes
  const defaultSettings = {
    autoShowPopup: true,
    showProductMatchesOnly: false,
    locationProductData: null,
    currentProductData: null,
    popupDelay: 5000, // Default 5 seconds if not provided
    cartAttributes: {} // New setting to store cart attributes
  };
  
  // Initialize function that will be called from the section
  window.branchStoreLocator.init = function(partnerLocationsJson, options) {
    // Merge default settings with passed options
    const settings = {...defaultSettings, ...options};
    
    // Check if the store_locator_test cart attribute is set to 'show_popup'
    // If not, don't initialize the store locator functionality
    if (settings.cartAttributes && settings.cartAttributes.store_locator_test !== 'show_popup') {
      console.log('Store locator test disabled by cart attribute:', settings.cartAttributes.store_locator_test);
      return;
    }
    
    // Parse the locations JSON
    let partnerLocations = [];
    try {
      partnerLocations = JSON.parse(partnerLocationsJson);
      //console.log('Store locator loaded with', partnerLocations.length, 'locations');
    } catch (e) {
      console.error('Failed to parse partner locations:', e);
      return;
    }
    
    // Helper functions
    function fixLongitude(longitude) {
      if (longitude === null || longitude === undefined) return null;
      return longitude > 30 ? -longitude : longitude;
    }
    
    function calculateDistance(lat1, lon1, lat2, lon2) {
      if (!lat1 || !lon1 || !lat2 || !lon2) return null;
      
      lat1 = parseFloat(lat1);
      lon1 = parseFloat(lon1);
      lat2 = parseFloat(lat2);
      lon2 = parseFloat(lon2);
      
      lon1 = fixLongitude(lon1);
      lon2 = fixLongitude(lon2);
      
      function deg2rad(deg) {
        return deg * (Math.PI/180);
      }
      
      const R = 6371; // Earth's radius in km
      const dLat = deg2rad(lat2 - lat1);
      const dLon = deg2rad(lon2 - lon1);
      const a = 
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
        Math.sin(dLon/2) * Math.sin(dLon/2); 
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      return R * c; // Distance in km
    }

    // Global event listener for store locator links
    document.addEventListener('click', function(event) {
        // Check if the clicked element has the store-locator-link class
        if (event.target.classList.contains('store-locator-link') || 
            event.target.closest('.store-locator-link')) {
            const link = event.target.classList.contains('store-locator-link') ? 
                      event.target : event.target.closest('.store-locator-link');
            
            const index = parseInt(link.getAttribute('data-location-index'), 10);
            if (!isNaN(index)) {
                showLocationPopup(index);
                // Reset the "closed" state when manually reopened
                sessionStorage.removeItem('branchPopupClosed');
            } else {
                // Fallback if index not found - try to show best match
                getUserLocation().then(locationData => {
                    if (locationData && locationData.bestMatch) {
                        showLocationPopup(locationData.bestMatch.index);
                        sessionStorage.removeItem('branchPopupClosed');
                    }
                });
            }
        }
    });

    // Centralized function to handle popup closing logic
    function handlePopupClose() {
      const popup = document.getElementById('location-popup');
      if (!popup) return;
      
      // Hide the popup
      popup.style.display = 'none';
      
      // Save that user has opted out for this session
      sessionStorage.setItem('branchPopupClosed', 'true');
      
      // Get the current location index from the popup
      const locationIndex = popup.getAttribute('data-current-location-index');
      
      // Replace header message if enabled AND not already replaced
      const headerReplaced = sessionStorage.getItem('headerMessageReplaced') === 'true';
      
      if (settings.enableHeaderReplacement && !headerReplaced) {
        //console.log('Replacing header message after popup interaction');
        replaceHeaderMessage(locationIndex);
        sessionStorage.setItem('headerMessageReplaced', 'true');
      } else if (headerReplaced) {
        //console.log('Header message already replaced, skipping animation');
      }
    }

    function replaceHeaderMessage(locationIndex) {
      // Check if locationIndex is valid
      if (locationIndex === undefined || locationIndex === null) {
          console.error('Invalid location index provided to replaceHeaderMessage function');
          return false;
      }
      
      // Get the location data
      const location = partnerLocations[locationIndex];
      if (!location) {
          console.error(`Location with index ${locationIndex} not found`);
          return false;
      }
      
      // Check if the location has a utility_bar_replacement_message field
      if (!location.utility_bar_replacement_message) {
          console.error(`Location with index ${locationIndex} doesn't have a utility_bar_replacement_message`);
          return false;
      }
      
      // Extract the HTML content from the rich text field
      let replacementHTML = '';
      
      // Check if utility_bar_replacement_message is an object (which happens with metafield_tag)
      if (typeof location.utility_bar_replacement_message === 'object') {
          // It's likely a metafield object, try to get the HTML content
          if (location.utility_bar_replacement_message.value) {
              replacementHTML = location.utility_bar_replacement_message.value;
          } else if (location.utility_bar_replacement_message.html) {
              replacementHTML = location.utility_bar_replacement_message.html;
          } else {
              // Fallback if we can't find the content in expected properties
              console.warn('Unable to extract HTML from utility_bar_replacement_message object', location.utility_bar_replacement_message);
              return false;
          }
      } else if (typeof location.utility_bar_replacement_message === 'string') {
          // If it's a string, use it directly
          replacementHTML = location.utility_bar_replacement_message;
      } else {
          // Unexpected type
          console.warn('Unexpected utility_bar_replacement_message type:', typeof location.utility_bar_replacement_message);
          return false;
      }
      
      // Extract content from inside p tags if they exist
      function extractFromPTags(html) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          
          // First check for metafield wrapper
          const metafieldWrapper = tempDiv.querySelector('.metafield-rich_text_field');
          if (metafieldWrapper) {
              tempDiv.innerHTML = metafieldWrapper.innerHTML;
          }
          
          // Check if there are p tags
          const paragraphs = tempDiv.querySelectorAll('p');
          if (paragraphs.length > 0) {
              let content = '';
              // Extract content from each p tag
              paragraphs.forEach(p => {
                  content += p.innerHTML + ' ';
              });
              return content.trim();
          }
          
          // If no p tags, return the original content
          return tempDiv.innerHTML;
      }
      
      // Extract the content from inside any p tags to avoid nesting
      replacementHTML = extractFromPTags(replacementHTML);
      
      //console.log('Final replacement HTML for header:', replacementHTML);
      
      // Store the location index in a data attribute for later retrieval
      const wrappedHTML = `<span class="store-locator-link" data-location-index="${locationIndex}" style="cursor: pointer;">${replacementHTML}</span>`;
      
      //console.log('Setting up header replacement with smooth transition');
      
      // Use setTimeout to delay the replacement
      setTimeout(function() {
          //console.log('Attempting to replace header message with fade transition');
          
          // Find ALL utility bar message elements (both desktop and mobile)
          const messageElements = document.querySelectorAll('.utility-bar__message p');
          
          if (messageElements && messageElements.length > 0) {
              //console.log(`Found ${messageElements.length} utility bar elements`);
              
              // Loop through all found elements and update them with fade transition
              messageElements.forEach((element, index) => {
                  // Check if the message is already the same (ignoring minor HTML differences)
                  const currentContent = element.innerHTML.trim();
                  // Extract just the text content for comparison to ignore minor HTML differences
                  const currentText = element.textContent.trim();
                  const newText = replacementHTML.trim();
                  
                  // If element already contains the store-locator-link class and same text, skip animation
                  if (element.querySelector('.store-locator-link') && currentText === newText) {
                      //console.log(`Element #${index + 1} already has the correct content, skipping animation`);
                      return; // Skip this element
                  }
                  
                 //console.log(`Updating utility bar element #${index + 1} with transition`);
                  
                  // Add transition CSS if not already present
                  if (!element.style.transition) {
                      element.style.transition = 'opacity 500ms ease-in-out';
                  }
                  
                  // Fade out
                  element.style.opacity = '0';
                  
                  // After fade out completes, update content and fade in
                  setTimeout(() => {
                      element.innerHTML = wrappedHTML;
                      
                      // Fade in after content is updated
                      setTimeout(() => {
                          element.style.opacity = '1';
                      }, 50); // Small delay to ensure DOM updates before transition starts
                  }, 500); // 500ms for fade out
              });
              
              //console.log('All utility bar messages will be replaced with fade transition');
              return true;
          } else {
              // Try to find the container elements instead
              const containerElements = document.querySelectorAll('.utility-bar__message');
              
              if (containerElements && containerElements.length > 0) {
                  //console.log(`Found ${containerElements.length} utility bar container elements`);
                  
                  // Loop through containers
                  containerElements.forEach((container, index) => {
                      const pElement = container.querySelector('p');
                      if (pElement) {
                          // Check if the message is already the same
                          const currentText = pElement.textContent.trim();
                          const newText = replacementHTML.trim();
                          
                          // If element already contains the store-locator-link class and same text, skip animation
                          if (pElement.querySelector('.store-locator-link') && currentText === newText) {
                              //console.log(`Container element #${index + 1} already has the correct content, skipping animation`);
                              return; // Skip this element
                          }
                          
                          //console.log('Found p element within container, updating with transition');
                          
                          // Add transition CSS if not already present
                          if (!pElement.style.transition) {
                              pElement.style.transition = 'opacity 500ms ease-in-out';
                          }
                          
                          // Fade out
                          pElement.style.opacity = '0';
                          
                          // After fade out completes, update content and fade in
                          setTimeout(() => {
                              pElement.innerHTML = wrappedHTML;
                              
                              // Fade in after content is updated
                              setTimeout(() => {
                                  pElement.style.opacity = '1';
                              }, 50); // Small delay to ensure DOM updates before transition starts
                          }, 500); // 500ms for fade out
                      } else {
                          //console.log('No p element found, updating container with new paragraph');
                          // For containers without a p element, create one with transition
                          const newP = document.createElement('p');
                          newP.style.opacity = '0';
                          newP.style.transition = 'opacity 500ms ease-in-out';
                          newP.innerHTML = wrappedHTML;
                          container.innerHTML = '';
                          container.appendChild(newP);
                          
                          // Fade in after appending
                          setTimeout(() => {
                              newP.style.opacity = '1';
                          }, 50);
                      }
                  });
                  
                  //console.log('All utility bar containers updated with fade transition');
                  return true;
              } else {
                  console.error('No utility bar elements found on the page');
                  return false;
              }
          }
      }, 5000); // 5000ms (5 seconds) delay before starting the transition
      
      return true;
  }

    function parseProductIds(rawData) {
      try {
        const productIds = JSON.parse(rawData);
        if (!Array.isArray(productIds)) return { success: false, productIds: [] };
        
        const numericIds = productIds.map(id => {
          if (typeof id === 'string' && id.includes('/')) {
            const parts = id.split('/');
            return parts[parts.length - 1];
          }
          return String(id);
        }).filter(Boolean);
        
        return { success: true, productIds: numericIds };
      } catch (e) {
        console.error('Error parsing product IDs:', e);
        return { success: false, productIds: [] };
      }
    }
    
    // Updated function to get product data for a location using the passed in data
    function getComplexDataForLocation(locationIndex) {
      try {
        //console.log(`Getting product data for location index: ${locationIndex}`);
        
        // Use the passed-in location product data
        if (!settings.locationProductData) {
          console.error('Location product data not provided in settings');
          return { productIds: [], parseError: true, elementHandle: "No data provided" };
        }
        
        // Find the location by index
        const location = settings.locationProductData.locations.find(loc => 
          parseInt(loc.index) === parseInt(locationIndex)
        );
        
        if (!location) {
          console.error(`Location with index ${locationIndex} not found in product data`);
          return { productIds: [], parseError: true, elementHandle: "No matching location" };
        }
        
        // Get the featured product IDs
        const productIds = location.featured_product_ids || [];
        
        //console.log(`Found ${productIds.length} featured product IDs for location ${locationIndex}:`, productIds);
        
        return {
          productIds: productIds.map(id => String(id)),
          parseError: false,
          elementHandle: location.handle || "No handle"
        };
      } catch (error) {
        console.error('Error getting product data for location:', error);
        return { productIds: [], parseError: true, elementHandle: "Error" };
      }
    }
    
    // Get user's location via geolocation API
    async function getUserLocation() {
      try {
          const response = await fetch('https://ipinfo.io/json?token=fcc331351b4fa3');
          const data = await response.json();
          
          //console.log('IP geolocation response:', data);
          
          const coords = data.loc.split(',');
          const userLatitude = parseFloat(coords[0]);
          const userLongitude = parseFloat(coords[1]);
          
          // Find nearby locations
          const locationsWithDistance = partnerLocations.map(location => {
          const distance = calculateDistance(
              userLatitude,
              userLongitude,
              location.latitude,
              location.longitude
          );
          
          // Explicitly check if within radius using numeric comparison
          const radius = parseFloat(location.store_locator_radius) || 30;
          const isWithinRadius = distance !== null && !isNaN(distance) && distance <= radius;
          
          return {
              ...location,
              distance: distance,
              isWithinRadius: isWithinRadius
          };
          });
          
          // IMPORTANT: Only include locations that are truly within radius
          const withinRadius = locationsWithDistance.filter(loc => loc.isWithinRadius === true);
          
          //console.log('Locations within radius:', withinRadius);
          
          // Sort by priority first (lower values = higher priority), then distance
          withinRadius.sort((a, b) => {
            if (a.store_locator_priority !== b.store_locator_priority) {
                return a.store_locator_priority - b.store_locator_priority; // Changed order to prioritize lower values
            }
            return a.distance - b.distance;
          });
          
          const bestMatch = withinRadius.length > 0 ? withinRadius[0] : null;
          
          return {
            locationFound: bestMatch !== null,
            userLocation: {
                city: data.city,
                region: data.region,
                country: data.country,
                latitude: userLatitude,
                longitude: userLongitude
            },
            locationsWithDistance: locationsWithDistance,
            withinRadius: withinRadius,
            bestMatch: bestMatch
          };
      } catch (error) {
          console.error('Error fetching location:', error);
          return {
            locationFound: false,
            error: error.message
          };
      }
    }
    
    // Check if current page matches any product, but only for nearby locations
    async function checkCurrentPageMatchesNearbyLocation() {
      try {
        const pathParts = window.location.pathname.split('/');
        if (pathParts.length >= 3 && pathParts[1] === 'products') {
            // Get user location first to determine nearby locations
            const locationData = await getUserLocation();
            const hasNearbyLocation = locationData && 
                                locationData.withinRadius && 
                                locationData.withinRadius.length > 0;
            
            if (!hasNearbyLocation) {
              //console.log('No nearby locations to check product match against');
              return { match: false };
            }
            
            const currentProductHandle = pathParts[2];
            //console.log('Current product handle:', currentProductHandle);
            
            // Get current product ID from settings if available
            let currentProductId = null;
            if (settings.currentProductData && settings.currentProductData.id) {
              currentProductId = settings.currentProductData.id.toString();
              //console.log('Current product ID from settings:', currentProductId);
            }
            
            // If we don't have a product ID, we can't make a reliable match
            if (!currentProductId) {
              //console.log('No product ID found, cannot check for match');
              return { match: false };
            }
            
            //console.log('Checking if product ID', currentProductId, 'matches any nearby locations');
            
            // Only check against nearby locations
            for (const nearbyLoc of locationData.withinRadius) {
              const locationIndex = nearbyLoc.index;
              //console.log(`Checking if product matches nearby location: ${nearbyLoc.store_name} (index: ${locationIndex})`);
              
              const complexData = getComplexDataForLocation(locationIndex);
              //console.log(`Location ${locationIndex} (${nearbyLoc.store_name}) product IDs:`, complexData.productIds);
              
              // Check if product ID is in this location's featured products
              if (complexData.productIds.includes(currentProductId)) {
                //console.log(`Found product match at nearby location ${locationIndex} (${nearbyLoc.store_name})`);
                return { match: true, locationIndex: locationIndex };
              }
            }
            
            //console.log('Product not found in any nearby location');
        }
        
        return { match: false };
      } catch (error) {
        console.error('Error checking product match:', error);
        return { match: false };
      }
    }

    // Function to show popup
    function showLocationPopup(locationIndex) {
      if (locationIndex === undefined || locationIndex === null) {
          console.error('Invalid location index');
          return;
      }
      
      const partner = partnerLocations[locationIndex];
      if (!partner) {
          console.error('Location not found:', locationIndex);
          return;
      }
      
      //console.log('Showing popup for location:', partner);
      
      // Find the popup element first
      const popup = document.getElementById('location-popup');
      if (!popup) {
          console.error('Popup element not found');
          return;
      }
      
      // Store the current location index as a data attribute on the popup
      popup.setAttribute('data-current-location-index', locationIndex);
      
      // Check if we're on a product page
      const isProductPage = window.location.pathname.includes('/products/');
      
      // Set the title based on page type
      let titleText;
      if (isProductPage) {
          // On product pages, use the specific title
          titleText = "Want to try it out in person?";
      } else if (partner.popup_title) {
          // On other pages, use the metaobject title if available
          titleText = partner.popup_title;
      } else {
          // Fallback to default title
          titleText = "Great news: you're near a Branch partner location!";
      }
      
      // Store name and city for subtitle
      const storeName = partner.store_name || 'Partner Location';
      const storeCity = partner.story_city || 'City';
      
      // Prepare subtitle HTML
      let subtitleHtml = '';
        if (partner.popup_subtitle) {
        //console.log('Raw subtitle:', partner.popup_subtitle);
        
        // Check if popup_subtitle is an object (which happens with metafield_tag)
        if (typeof partner.popup_subtitle === 'object') {
            // It's likely a metafield object, try to get the HTML content
            if (partner.popup_subtitle.value) {
            subtitleHtml = partner.popup_subtitle.value;
            } else if (partner.popup_subtitle.html) {
            subtitleHtml = partner.popup_subtitle.html;
            } else {
            // Fallback if we can't find the content in expected properties
            console.warn('Unable to extract HTML from popup_subtitle object', partner.popup_subtitle);
            subtitleHtml = 'Visit our showroom to experience our products in person.';
            }
        } else if (typeof partner.popup_subtitle === 'string') {
            // If it's a string, use it directly
            subtitleHtml = partner.popup_subtitle;
        } else {
            // Unexpected type
            console.warn('Unexpected popup_subtitle type:', typeof partner.popup_subtitle);
            subtitleHtml = 'Visit our showroom to experience our products in person.';
        }
        
        // Extract content from inside p tags if they exist
        function extractFromPTags(html) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            
            // First check for metafield wrapper
            const metafieldWrapper = tempDiv.querySelector('.metafield-rich_text_field');
            if (metafieldWrapper) {
            tempDiv.innerHTML = metafieldWrapper.innerHTML;
            }
            
            // Check if there are p tags
            const paragraphs = tempDiv.querySelectorAll('p');
            if (paragraphs.length > 0) {
            let content = '';
            // Extract content from each p tag
            paragraphs.forEach(p => {
                content += p.innerHTML + ' ';
            });
            return content.trim();
            }
            
            // If no p tags, return the original content
            return tempDiv.innerHTML;
        }
        
        // Extract the content from inside any p tags to avoid nesting
        subtitleHtml = extractFromPTags(subtitleHtml);
        
        //console.log('Final subtitle HTML (after p tag extraction):', subtitleHtml);
        } else {
        // Customize based on appointment requirements as fallback
        if (partner.appointment_required) {
            subtitleHtml = `
            Visit our ${storeName} in ${storeCity} to try out a selection of our products in person. 
            <strong>Appointments are required</strong> - please book in advance.
            `;
        } else {
            subtitleHtml = `
            Visit our ${storeName} in ${storeCity} to try out a selection of our products in person. 
            Visit our Partner Page to see what's in stock.
            `;
        }
        }
      
      // Get Google Maps link - handle the case where it might be a JSON string
      let googleMapsUrl = '#';
      try {
        if (partner.google_maps_link) {
          if (partner.google_maps_link.includes('url')) {
            // It's likely a JSON string
            const linkData = JSON.parse(partner.google_maps_link.replace(/&quot;/g, '"'));
            googleMapsUrl = linkData.url || '#';
          } else {
            // It's a direct URL
            googleMapsUrl = partner.google_maps_link;
          }
        }
      } catch (e) {
        console.error('Error parsing Google Maps link:', e);
        googleMapsUrl = partner.google_maps_link || '#';
      }

        // Enhanced function to parse link metafields and extract both URL and text
        function parseLinkWithText(linkValue, defaultText = '') {
        if (!linkValue) return { url: '#', text: defaultText };
        
        try {
            // Check if it's a JSON string containing an object with url and text
            if (typeof linkValue === 'string' && (linkValue.includes('url') || linkValue.includes('"url"'))) {
            // Parse the JSON string
            const linkData = JSON.parse(linkValue.replace(/&quot;/g, '"'));
            
            return {
                url: linkData.url || '#',
                text: linkData.text || defaultText
            };
            } else {
            // It's a direct URL without text
            return {
                url: linkValue,
                text: defaultText
            };
            }
        } catch (e) {
          console.error('Error parsing link:', e);
            return {
            url: linkValue || '#',
            text: defaultText
            };
        }
        }

        // Function to determine if a URL is external
        function isExternalUrl(url) {
        if (!url || url === '#') return false;
        
        // Check if URL starts with http or https and doesn't contain the current domain
        return (url.startsWith('http://') || url.startsWith('https://')) && 
                !url.includes(window.location.hostname);
        }

        // Get first and second CTA data
        let firstCTA;
        let secondCTA;

        // Check if appointment booking link exists
        const hasAppointmentLink = partner.appointment_booking_link && partner.appointment_booking_link !== 'null';

        if (hasAppointmentLink) {
        // If appointment booking link exists, use it for first CTA regardless of appointment_required setting
        //console.log('Using appointment booking link for first CTA');
        firstCTA = parseLinkWithText(partner.appointment_booking_link, "BOOK AN APPOINTMENT");
        
        // Second CTA comes from second_cta field
        secondCTA = parseLinkWithText(partner.second_cta, "VISIT OUR PARTNER LOCATION PAGE");
        } else {
        // If no appointment booking link, use google maps for first CTA
        //console.log('Using Google Maps link for first CTA');
        firstCTA = parseLinkWithText(partner.google_maps_link, "GET DIRECTIONS");
        
        // Second CTA comes from second_cta field
        secondCTA = parseLinkWithText(partner.second_cta, "VISIT OUR PARTNER LOCATION PAGE");
        }

        // Determine if links should open in new tab
        const firstCTATarget = isExternalUrl(firstCTA.url) ? ' target="_blank" rel="noopener"' : '';
        const secondCTATarget = isExternalUrl(secondCTA.url) ? ' target="_blank" rel="noopener"' : '';

        // Build the buttons HTML with appropriate targets and data attributes
        const ctaButtonsHtml = `
        <a href="${firstCTA.url}"${firstCTATarget} class="btn popup-cta-button" data-cta-type="primary">${firstCTA.text}</a>
        <a href="${secondCTA.url}"${secondCTATarget} class="btn v2 popup-cta-button" data-cta-type="secondary">${secondCTA.text}</a>
        `;
      
      // Update the popup HTML template to include the "don't show this again" text
      const popupHTML = `
        <div class="location-popup-content">
            <div class="close-button">×</div>
            <h2 class="location-popup-title">${titleText}</h2>
            <p class="location-popup-subtitle">${subtitleHtml}</p>
            <div class="location-popup-ctas">
            ${ctaButtonsHtml}
            </div>
            <p class="location-popup-dont-show">Don't show this again</p>
        </div>
        `;

      // Replace the entire popup content
      popup.innerHTML = popupHTML;

      // Show the popup
      popup.style.display = 'flex';

      // Track that popup was shown via cart attribute
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          attributes: {
            'store_locator_popup_shown': 'true'
          }
        })
      });

      // Add event listener to the close button
      const closeButton = popup.querySelector('.close-button');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          handlePopupClose();
        });
      }

      // Add event listener for "Don't show this again"
      const dontShowAgainText = popup.querySelector('.location-popup-dont-show');
      if (dontShowAgainText) {
        dontShowAgainText.addEventListener('click', function() {
          handlePopupClose();
        });
      }

      // Add event listeners to CTA buttons to handle popup close
      const ctaButtons = popup.querySelectorAll('.popup-cta-button');
      ctaButtons.forEach(button => {
        button.addEventListener('click', function(event) {
          // Log the CTA interaction for analytics if needed
          const ctaType = this.getAttribute('data-cta-type');
          //console.log(`CTA button clicked: ${ctaType}`);
          
          // Handle popup close to prevent it from showing again
          handlePopupClose();
          
          // Let the link navigation proceed normally
          // The event will continue to bubble and the link will work as expected
        });
      });
    }
    
    // Main initialization function
    async function initializeStoreLocator(forceRefresh = false) {
      //console.log('Initializing store locator with settings:', settings);
      
      try {
          // Step 1: Get user location first
          const locationData = await getUserLocation();
          //console.log('User location data:', locationData);
          
          // Check if header message should be replaced (after we have location data)
          const popupClosed = sessionStorage.getItem('branchPopupClosed') === 'true';
          const headerReplaced = sessionStorage.getItem('headerMessageReplaced') === 'true';
          
          // If popup was closed before, try to replace the header
          if (popupClosed && settings.enableHeaderReplacement) {
            //console.log('Attempting to replace header for closed popup');
            // Now we can safely use locationData
            if (locationData && locationData.bestMatch) {
              replaceHeaderMessage(locationData.bestMatch.index);
            }
            sessionStorage.setItem('headerMessageReplaced', 'true');
          }
          
          // Set up variables for decision
          const isProductPage = window.location.pathname.includes('/products/');
          //console.log('Is product page:', isProductPage);
          
          const hasNearbyLocation = locationData && 
                                  locationData.withinRadius && 
                                  locationData.withinRadius.length > 0;
          //console.log('Has nearby location within radius:', hasNearbyLocation);
          
          //console.log('showProductMatchesOnly setting:', settings.showProductMatchesOnly);
          
          // Make decision about showing popup
          let shouldShowPopup = false;
          let popupLocationIndex = null;
          let reason = '';

          if (isProductPage && settings.showProductMatchesOnly) {
            // We're on a product page in product-matches-only mode
            // Check if the current product is featured in any nearby location
            
            // Only check for product matches in nearby locations
            if (hasNearbyLocation) {
                // Check each nearby location for a product match
                let foundMatch = false;
                
                for (const nearbyLoc of locationData.withinRadius) {
                  const locationIndex = nearbyLoc.index;
                  //console.log(`Checking if product matches nearby location: ${nearbyLoc.store_name}`);
                  
                  // Skip this location if show_location_pop_up is false
                  if (nearbyLoc.show_location_pop_up === false) {
                    //console.log(`Skipping location ${nearbyLoc.store_name} because show_location_pop_up is false`);
                    continue;
                  }
                  
                  const complexData = getComplexDataForLocation(locationIndex);
                  
                  // Try to get the product ID from settings
                  let currentProductId = null;
                  if (settings.currentProductData && settings.currentProductData.id) {
                      currentProductId = settings.currentProductData.id.toString();
                  }
                  
                  // Check if product ID is in this location's featured products
                  if (currentProductId && complexData.productIds.includes(currentProductId)) {
                      //console.log(`Product matches nearby location ${locationIndex}`);
                      shouldShowPopup = true;
                      popupLocationIndex = locationIndex;
                      reason = 'Product matches nearby location';
                      foundMatch = true;
                      break;
                  }
                }
                
                if (!foundMatch) {
                  // Product doesn't match any nearby location
                  shouldShowPopup = false;
                  reason = 'Product not featured in any nearby location';
                }
            } else {
                // No nearby locations in product-only mode
                shouldShowPopup = false;
                reason = 'No nearby locations in product-only mode';
            }
          } else if (!isProductPage && hasNearbyLocation) {
            // Non-product page with nearby location (collection or page)
            // Find the best match with show_location_pop_up enabled
            let bestMatchWithPopup = null;
            
            for (const loc of locationData.withinRadius) {
              if (loc.show_location_pop_up !== false) {
                bestMatchWithPopup = loc;
                break;
              }
            }
            
            if (bestMatchWithPopup) {
              shouldShowPopup = true;
              popupLocationIndex = bestMatchWithPopup.index;
              reason = 'Non-product page with nearby location';
            } else {
              shouldShowPopup = false;
              reason = 'All nearby locations have show_location_pop_up set to false';
            }
          } else if (isProductPage && hasNearbyLocation && !settings.showProductMatchesOnly) {
            // Product page, not in product-only mode, with nearby location
            // Find the best match with show_location_pop_up enabled
            let bestMatchWithPopup = null;
            
            for (const loc of locationData.withinRadius) {
              if (loc.show_location_pop_up !== false) {
                bestMatchWithPopup = loc;
                break;
              }
            }
            
            if (bestMatchWithPopup) {
              shouldShowPopup = true;
              popupLocationIndex = bestMatchWithPopup.index;
              reason = 'Product page (not in product-only mode) with nearby location';
            } else {
              shouldShowPopup = false;
              reason = 'All nearby locations have show_location_pop_up set to false';
            }
          } else {
            // Any other case
            shouldShowPopup = false;
            reason = 'No conditions met for showing popup';
          }
          
          // Show popup based on decision
          console.log('Popup decision:', {
            shouldShowPopup,
            popupLocationIndex,
            reason,
            autoShowPopup: settings.autoShowPopup
          });
          
          // Before showing the popup, check if user already closed it
          if (shouldShowPopup && popupLocationIndex !== null && (settings.autoShowPopup || forceRefresh)) {
            // Check if user has already closed the popup
            const popupClosed = sessionStorage.getItem('branchPopupClosed') === 'true';
            
            if (!popupClosed) {
              const popupLocation = partnerLocations[popupLocationIndex];
              // Get the delay from settings (or use default)
              const delayTime = settings.popupDelay || 10000;
              //console.log(`Will show popup after ${delayTime/1000} second delay for:`, popupLocation);
              
              // Set a timeout before showing the popup
              setTimeout(() => {
                // Check again if popup was closed during the wait time
                const stillNotClosed = sessionStorage.getItem('branchPopupClosed') !== 'true';
                
                if (stillNotClosed) {
                  //console.log('Showing popup after delay');
                  showLocationPopup(popupLocationIndex);
                } else {
                  //console.log('Popup was closed during delay period');
                }
              }, delayTime); // Use the configurable delay time
            } else {
              //console.log('Not showing popup: User has already closed it');
            }
          } else {
            //console.log('Not showing popup: ' + reason);
          }
          
      } catch (error) {
          console.error('Error in store locator initialization:', error);
      }
    }
  
    // Start the store locator
    initializeStoreLocator();
  };
})();